import * as React from 'react';
import { ExpandablePanel } from 'ui';
import { fieldsMap } from '../../../containers/group-by/fields-map';
import { FieldItem, ItemTypes } from '../../../types';
import { SelectionsField } from './selections-field';
import { SortItem } from './sortable/sort-item';
import { dropPanelForItemType } from 'app/area/reports/components/drop-panel';
import { dragPanelForItemType } from 'app/area/reports/components/drag-panel';
import { GroupByFieldState } from '../types-store';
import { SelectionFieldItem } from '../types-fields';
import { ButtonSelectMultipleDialog } from 'app/area/reports/components/button-select-multiple-dialog';
import { DropArea } from 'app/area/reports/components/drop-area';
import styles from '../../dnd.scss';
import { withCachedTranslation } from 'app/components/enhancers/with-cached-translation';
import { GroupByPanelTexts } from 'app/area/reports/containers/group-by/components/group-by-panel-texts';

const GroupByDropPanel = dropPanelForItemType(ItemTypes.GROUPBY_FIELD);

const GroupByDragField = dragPanelForItemType(ItemTypes.GROUPBY_FIELD);

export interface GroupByPanelProps {
  disabled: boolean;
  orderNumber: string;
  maxSelectionCriteria: number;

  fetching: boolean;

  data: GroupByFieldState;
  selectedGroupByFields: SelectionFieldItem[];

  onLoadGroupByFields: (query?: string) => void;
  onUpdateDefaultGroupByFields: (items: FieldItem[]) => void;
  onSelectGroupBy: (selectionsField: SelectionFieldItem) => void;
  onModifyGroupBySelections: (fields: SelectionFieldItem[]) => void;

  translation: GroupByPanelTexts;
}

class GroupByPanelComponent extends React.PureComponent<
  GroupByPanelProps
  > {

  private addingAvailable = () => {
    if (!!this.props.maxSelectionCriteria) {
      return this.props.selectedGroupByFields.length < this.props.maxSelectionCriteria;
    }
    return false;
  };

  private onSelectGroupBySingle = (field: FieldItem) => {

    if (this.addingAvailable()) {
      this.props.onSelectGroupBy({
        field
      });
    }
  };

  private onChangeSelectionType = (modifiedItem: SelectionFieldItem) => {
    const modifiedLGroupByFields = [...this.props.selectedGroupByFields];
    const indexOfModifiedItem = this.props.selectedGroupByFields.findIndex(
      i => i.selectionNo === modifiedItem.selectionNo
    );
    modifiedLGroupByFields.splice(indexOfModifiedItem, 1, modifiedItem);

    this.props.onModifyGroupBySelections(modifiedLGroupByFields);
  };

  private handleOnSelect = (items: FieldItem[]) => {
    this.props.onUpdateDefaultGroupByFields([...this.props.data.defaultGroupByFields, ...items.map(i => ({added: true, ...i}))]);
  };

  private findFieldIndex = (field: SelectionFieldItem) => {
    return this.props.selectedGroupByFields.indexOf(field);
  };

  private moveField = (droppedId: number, destinationId: number) => {
    if (droppedId !== destinationId) {
      const updatedFields = fieldsMap.moveField(this.props.selectedGroupByFields, droppedId, destinationId);
      this.props.onModifyGroupBySelections(updatedFields);
    }
  };

  private renderContent = () => {
    const {
      disabled,
      data: {
        defaultGroupByFields = [],
        sortOrderTypes = [],
        additionalGroupByFields = []
      },
      selectedGroupByFields,
      onLoadGroupByFields,
      translation
    } = this.props;

    return (
      <div className="row">
        <div className="col-6">
          <ul className={styles.dragTagContainer}>
            {defaultGroupByFields.map(item => {
              return (
                <GroupByDragField
                  key={`${item.value}`}
                  className={styles.dragTag}
                  field={item}
                  isSelected={false}
                  added={item.added}
                  onSelect={this.onSelectGroupBySingle}
                />
              );
            })}
            <ButtonSelectMultipleDialog
              disabled={disabled}
              className={styles.dragTag}
              options={additionalGroupByFields}
              placeholder={translation.group_by_search}
              textButtonAdd={`+ ${translation.group_by_btn_open_dialog}`}
              textTitle={translation.group_by_dialog_title}
              textConfirm={translation.group_by_done}
              onLoadOptions={onLoadGroupByFields}
              onSelect={this.handleOnSelect}
            />
          </ul>
        </div>
        <div className="col-6">
          <GroupByDropPanel
            className={styles.dropBox}
            addItem={this.onSelectGroupBySingle}>
            {selectedGroupByFields
              .map(
                (item: SelectionFieldItem) => (
                  <SortItem
                    key={`${item.selectionNo}`}
                    field={item}
                    findField={this.findFieldIndex}
                    moveField={this.moveField}
                  >
                    <SelectionsField
                      item={item}
                      selectedGroupByFields={selectedGroupByFields}
                      sortOrderTypes={sortOrderTypes}
                      onModifyGroupBySelections={this.props.onModifyGroupBySelections}
                      onChangeSelectionField={this.onChangeSelectionType}

                      translation={this.props.translation}
                    />
                  </SortItem>
                )
              )}
            {this.addingAvailable() && <DropArea text={translation.group_by_drag_n_drop_panel} />}
          </GroupByDropPanel>
        </div>
      </div>
    );
  };

  public render(): JSX.Element {
    const {
      translation, orderNumber
    } = this.props;

    return (
      <ExpandablePanel title={`${orderNumber}. ${translation.group_by_area_title}`}>
        {this.renderContent()}
      </ExpandablePanel>
    );
  }
}

export const GroupByPanel = withCachedTranslation<GroupByPanelProps>(GroupByPanelComponent);
